import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import Close from "@mui/icons-material/Close";

export interface ContactInfo {
  name: string;
  email?: string | null;
  phone?: string | null;
  title?: string | null;
}

interface UniqueContactsModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  contacts: ContactInfo[];
}

export function UniqueContactsModal({
  open,
  onClose,
  title,
  contacts,
}: UniqueContactsModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        {contacts.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 2 }}>
            No contacts found
          </Typography>
        ) : (
          <List disablePadding>
            {contacts.map((contact, index) => (
              <Box key={`${contact.name}-${contact.email}-${index}`}>
                {index > 0 && <Divider />}
                <ListItem sx={{ px: 0, py: 1.5 }}>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle2" fontWeight={600}>
                        {contact.name}
                      </Typography>
                    }
                    secondary={
                      <Box component="span" sx={{ display: "block", mt: 0.5 }}>
                        {contact.title && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            component="span"
                            sx={{ display: "block" }}
                          >
                            {contact.title}
                          </Typography>
                        )}
                        {contact.email && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            component="span"
                            sx={{ display: "block" }}
                          >
                            {contact.email}
                          </Typography>
                        )}
                        {contact.phone && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            component="span"
                            sx={{ display: "block" }}
                          >
                            {contact.phone}
                          </Typography>
                        )}
                      </Box>
                    }
                  />
                </ListItem>
              </Box>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
}
